import eventDetail from "./eventDetail.vue";
export default eventDetail;
